// extracted by mini-css-extract-plugin
export var hidden = "_t6-0";